import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import ProductCard from "../components/ProductCard";
import { useCart } from "../context/CartContext";
import { apiGetProducts } from "../api";

const Wishlist = () => {
  const { wishlist } = useCart();
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGetProducts()
      .then(setAllProducts)
      .catch(() => setAllProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const items = allProducts.filter((p) => wishlist.includes(p.id));

  if (loading) {
    return (
      <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-10 min-h-[60vh]">
        <h1 className="font-serif text-3xl text-neutral-900 mb-8">My Wishlist</h1>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="aspect-[3/4] bg-neutral-200 rounded-sm" />
              <div className="h-3 bg-neutral-200 rounded mt-3 w-1/2" />
              <div className="h-4 bg-neutral-200 rounded mt-2 w-3/4" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-10 min-h-[60vh]">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-3xl text-neutral-900">My Wishlist</h1>
        {items.length > 0 && (
          <span className="text-sm text-neutral-500">{items.length} {items.length === 1 ? "item" : "items"}</span>
        )}
      </div>

      {items.length === 0 ? (
        <div className="py-20 text-center">
          <Heart className="h-14 w-14 text-neutral-300 mx-auto" />
          <p className="text-neutral-500 mt-4 text-lg">Your wishlist is empty.</p>
          <p className="text-neutral-400 text-sm mt-1">Save your favourite fragrances here.</p>
          <Link
            to="/collections/all"
            className="mt-6 inline-block bg-[#c9954a] text-[#0f0c0a] px-8 py-3 text-sm font-semibold uppercase tracking-widest rounded-sm hover:bg-[#b8843e] transition-colors"
          >
            Explore Fragrances
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
